/**
 * @docs
 *   https://www.apollographql.com/docs/react/get-started/
 *   https://www.apollographql.com/docs/react/migrating/boost-migration/
 */

import fetch from 'node-fetch'
import { ApolloClient, ApolloLink, Observable, InMemoryCache, HttpLink } from '@apollo/client'
import { onError } from '@apollo/client/link/error'

const cache = new InMemoryCache()

const requestLink = new ApolloLink((operation, forward) =>
  new Observable(observer => {
    let handle: any
    Promise.resolve(operation)
      .then(() => {
        handle = forward(operation).subscribe({
          next: observer.next.bind(observer),
          error: observer.error.bind(observer),
          complete: observer.complete.bind(observer)
        })
      })
      .catch(observer.error.bind(observer))

    return () => {
      if (handle) handle.unsubscribe()
    }
  })
)

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_WP_GRAPHQL_URL,
  // @ts-expect-error
  fetch,
  credentials: 'same-origin'
})

export const makeApolloClient = () => {
  return new ApolloClient({
    link: ApolloLink.from([
      onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
          graphQLErrors.map(({ message, locations, path }) =>
            console.log( // eslint-disable-line
              `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`
            )
          )
        }
        if (networkError) {
          console.log(`[Network error]: ${networkError}`) // eslint-disable-line
        }
      }),
      requestLink,
      httpLink
    ]),
    cache
  })
}
